import { DecodedValueMap, NumberParam, SetQuery } from 'use-query-params'
import { GlobalDialogFormsParams } from '@components/GlobalDialogForms'

export const CartParams = {
  ...GlobalDialogFormsParams,
  editLinePk: NumberParam,
  favoritesPage: NumberParam,
  page: NumberParam,
  paginateBy: NumberParam,
}

export type TCartParams = DecodedValueMap<typeof CartParams>
export type TCartSetParams = SetQuery<typeof CartParams>
